import { render } from "./RoleSet.vue?vue&type=template&id=6ba0e156&scoped=true&ts=true"
import script from "./RoleSet.vue?vue&type=script&lang=ts"
export * from "./RoleSet.vue?vue&type=script&lang=ts"

import "./RoleSet.vue?vue&type=style&index=0&id=6ba0e156&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba0e156"]])

export default __exports__